/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Step_Connect_DescriptionInputs */

const en_landing_step_connect_description = /** @type {(inputs: Landing_Step_Connect_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get your research directly into client workflows, moving beyond the inbox.`)
};

/**
* | output |
* | --- |
* | "Get your research directly into client workflows, moving beyond the inbox." |
*
* @param {Landing_Step_Connect_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_step_connect_description = /** @type {((inputs?: Landing_Step_Connect_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Step_Connect_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_step_connect_description(inputs)
});